import type { OnboardingStep } from '@/types/onboarding'

export interface StepDefinition {
  key: OnboardingStep
  label: string
  index: number
}

export const ONBOARDING_STEP_DEFINITIONS: StepDefinition[] = [
  { key: 'account', label: 'Account', index: 0 },
  { key: 'credentials', label: 'Credentials', index: 1 },
  { key: 'agreements', label: 'Agreements', index: 2 },
  { key: 'stripe_connect', label: 'Payments', index: 3 },
  { key: 'practice_profile', label: 'Practice', index: 4 },
  { key: 'provider_profile', label: 'Profile', index: 5 },
  { key: 'visit_types', label: 'Visit Types', index: 6 },
  { key: 'availability', label: 'Availability', index: 7 },
  { key: 'protocol_review', label: 'Protocol', index: 8 },
  { key: 'go_live', label: 'Go Live', index: 9 },
]

export const ONBOARDING_STEP_COUNT = ONBOARDING_STEP_DEFINITIONS.length
